import { CustomReport } from "../models/CustomReport";

export class CustomReportSearchResult {
    constructor(
        public customReportId: string,
        public customReport: CustomReport,
        public path: Array<number>,
        public topLevelParent: CustomReport | undefined,
        public parent?: CustomReport
    ) { }
}

export class CustomReportsSearchService {

    public static findCustomReportByIdRecursive(
        customReports: CustomReport[],
        targetId: string
    ): CustomReportSearchResult | null {
        return this.search(customReports, targetId);
    }

    private static search(
        customReports: CustomReport[],
        targetId: string,
        parent?: CustomReport,
        topLevelParent?: CustomReport,
        path: number[] = []
    ): CustomReportSearchResult | null {
        for (let i = 0; i < customReports.length; i++) {
            const customReport = customReports[i];
            const currentPath = [...path, i];
            const currentTopLevel = topLevelParent ?? customReport;

            if (customReport.id === targetId) {
                return new CustomReportSearchResult(targetId, customReport, currentPath, currentTopLevel, parent);
            }

            const nestedCustomReports = customReport.configuration?.reports;
            if (Array.isArray(nestedCustomReports)) {
                throw new Error("CustomReports containing child customReports is not supported.");
            }
        }

        return null;
    }

    public static setCustomReportAtPath(
        topLevelParent: CustomReport,
        path: number[],
        newCustomReport: CustomReport
    ): boolean {
        if (path.length === 0) return false; // Nothing to replace

        let currentCustomReports = topLevelParent.configuration?.reports;
        if (!Array.isArray(currentCustomReports)) return false;

        // Traverse to the parent of the target customReport
        for (let i = 0; i < path.length - 1; i++) {
            const index = path[i];
            const customReport = currentCustomReports[index];
            if (!customReport?.configuration?.reports) return false;

            currentCustomReports = customReport.configuration.reports;
        }

        const targetIndex = path[path.length - 1];

        // Replace the target customReport
        if (currentCustomReports && currentCustomReports[targetIndex]) {
            currentCustomReports.splice(targetIndex, 1, newCustomReport);
            return true;
        }

        return false;
    }
}
